<template>
  <div id="index">
    <div class="indexCont">
      <div class="list">
        <ul>
          <li>
            <p class="tab1">序号</p>
            <p class="tab2">歌曲</p>
            <p class="tab3">操作</p>
            <p class="tab4">简介</p>
          </li>
          <li v-for="item in list" :key="item.index">
            <div class="tab1">{{item.index}}</div>
            <div class="tab2">{{item.name}}</div>
            <div class="tab3">
              <!-- <p v-if="play == item.index" @click="pause">
                <img src="../assets/pause.png" alt="" class="pause">
              </p> -->
              <p v-if="play != item.index" @click="playMusic" :data-index="item.index" :data-url="item.url">
                <img src="../assets/play.png" alt="" class="play">
              </p>
              <p>
                <a :href="item.url" :download="item.name + '.mp3'" target="_blank"></a>
              </p>
            </div>
            <div class="tab4">{{item.desc}}</div>
          </li>
        </ul>
      </div>
      <div class="_swiper">
        <swiper :options="swiperOptions">
          <swiper-slide>
            <img src="../assets/pic1.png" alt="" class="pic">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/pic2.png" alt="" class="pic">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/pic3.png" alt="" class="pic">
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <audio ref="audio" :src="thisSrc" @canplay="canplay"></audio>
  </div>
</template>

<script>

import '../sass/index.min.css'

export default {
  name:'index',
  data(){
    return{
      list:[
        {
          index:'1',
          name:'忧伤的雨',
          url:'http://image.shengu999.com/www/ysdy.mp3',
          desc:'窗外的夜空下起了细雨'
        },
        {
          index:'2',
          name:'全新的天空',
          url:'http://image.shengu999.com/www/qxdtk.mp3',
          desc:'渴望一切停止不动'
        },
        {
          index:'3',
          name:'因为爱而存在',
          url:'http://image.shengu999.com/www/ywaecz.mp3',
          desc:'记住我的笑容和我的温柔'
        },
        {
          index:'4',
          name:'其实不爱就不爱',
          url:'http://image.shengu999.com/www/qsbajba.mp3',
          desc:'没有你我的心只要一分钟就会觉得孤单'
        },
        {
          index:'5',
          name:'诺言游戏',
          url:'http://image.shengu999.com/www/nyyx.mp3',
          desc:'我穿越人世间 才想起你的脸'
        },
        {
          index:'6',
          name:'品尝着甜蜜',
          url:'http://image.shengu999.com/www/pcztm.mp3',
          desc:'品尝着甜蜜，不要离开我'
        },
        {
          index:'7',
          name:'漂亮甜心',
          url:'http://image.shengu999.com/www/pltx.mp3',
          desc:'你的微笑画出彩虹让我着迷 我的明天想交给你管理'
        },
        {
          index:'8',
          name:'你总是规定太多',
          url:'http://image.shengu999.com/www/nzsgdtd.mp3',
          desc:'热热浓浓的咖啡 爱情总是让人依偎 承认自己很怕黑 寂寞空虚没有人陪'
        },
        {
          index:'9',
          name:'平静的海面',
          url:'http://image.shengu999.com/www/pjdhm.mp3',
          desc:'当爱站在你的对面 他会迷失你的双眼'
        },
        {
          index:'10',
          name:'女人的狠心',
          url:'http://image.shengu999.com/www/nedhx.mp3',
          desc:'一个人的夜 特别孤单 折磨人的想念 你却看不见'
        },
        
      ],
      swiperOptions:{
        slidesPerView: 3,
        centeredSlides: true,
        loop: true,
        spaceBetween: 20,
        autoplay: true,
      },
      play:0,
      thisSrc:null,
      playing:0,
    }
  },
  methods:{
    download(e){
      //下载
      console.log(e.target.dataset);
    },
    playMusic(e){
      this.thisSrc = e.target.dataset.url;
      console.log(this.$refs.audio.play());
      this.$refs.audio.play();
      this.playing = e.target.dataset.index;
    },
    canplay(e){
      console.log('canplay',e);
      this.$refs.audio.play();
      this.play = this.playing;
    },
    pause(){
      //停止播放
      this.play = 0;
      this.$refs.audio.pause();
    }
  },
  created(){
    this.$myStore.setMessageAction(0);
  },
  mounted(){

  }
}
</script>